<template>
  <div class="ov-page">
    <div class="ov-card">
      <div class="ov-card__head">
        <div class="ov-card__title">
          Offres
          <span class="ov-count">{{ filteredItems.length }}</span>
        </div>
        <div class="ov-filters">
          <button type="button" class="ov-btn ov-btn--primary ov-btn--sm" @click="$router.push('/creerOffreVoyage')">
            <v-icon small>mdi-plus</v-icon>
            Nouvelle offre
          </button>
          <div class="ov-search">
            <v-icon small>mdi-magnify</v-icon>
            <input v-model="search" type="text" class="ov-input" placeholder="Rechercher..." />
          </div>
          <select v-model="filterType" class="ov-select">
            <option value="">Tous les types</option>
            <option v-for="t in offerTypes" :key="t" :value="t">{{ t }}</option>
          </select>
          <select v-model="filterStatus" class="ov-select">
            <option value="all">Tous les statuts</option>
            <option value="active">Actif</option>
            <option value="inactive">Inactif</option>
          </select>
        </div>
      </div>

      <v-data-table
        :headers="headers"
        :items="filteredItems"
        :loading="loading"
        :search="search"
        loader-height="2"
        no-data-text="Aucune offre de voyage"
        class="ov-table"
      >
        <template v-slot:[`item.designation`]="{ item }">
          <span class="sel-designation">{{ item.designation }}</span>
        </template>

        <template v-slot:[`item.isActif`]="{ item }">
          <span v-if="item.isActif" class="ov-badge ov-badge--success">{{ $t('travelOffer.active') }}</span>
          <span v-else class="ov-badge ov-badge--neutral">{{ $t('travelOffer.inactive') }}</span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="ov-row-actions">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <button type="button" class="ov-icon-btn" v-bind="attrs" v-on="on" @click="editerOffreVoyage(item)">
                  <v-icon small>mdi-pencil-outline</v-icon>
                </button>
              </template>
              <span>{{ $t('travelOffer.edit') }}</span>
            </v-tooltip>
            <v-tooltip v-if="!item.isActif" bottom>
              <template v-slot:activator="{ on, attrs }">
                <button type="button" class="ov-icon-btn" v-bind="attrs" v-on="on" @click="activerOffreVoyage(item)">
                  <v-icon small>mdi-broadcast</v-icon>
                </button>
              </template>
              <span>{{ $t('travelOffer.activate') }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </div>

    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
  </div>
</template>

<script>
import axios from "axios";
import {
  API_RECUPERER_LISTE_OFFRE_VOYAGE,
  API_ACTIVER_OFFRE_DE_VOYAGE,
  HEADERS,
} from "@/components/globalConfig/globalConstConfig";
import { showErrorMessage } from "../messages/messageProcess";

export default {
  name: "SelectionnerOffreVoyage",
  computed: {
    offerTypes() {
      return [...new Set(
        this.offreVoyageDisponibleList
          .map(o => o.typeOffreVoyageDesignation)
          .filter(Boolean)
      )];
    },
    filteredItems() {
      return this.offreVoyageDisponibleList.filter(item => {
        const matchType = !this.filterType || item.typeOffreVoyageDesignation === this.filterType;
        const matchStatus =
          this.filterStatus === 'all' ||
          (this.filterStatus === 'active' && item.isActif) ||
          (this.filterStatus === 'inactive' && !item.isActif);
        return matchType && matchStatus;
      });
    },
  },

  data() {
    return {
      errorMsg: null,
      loading: true,
      search: "",
      filterType: "",
      filterStatus: "all",
      headers: [
        { text: "reference", value: "id" },
        { text: "Designation", value: "designation" },
        { text: this.$t('travelOffer.offerType'), value: "typeOffreVoyageDesignation" },
        { text: this.$t('travelOffer.departure'), value: "villeDepartDesignation" },
        { text: this.$t('travelOffer.arrival'), value: "villeDestinationDesignation" },
        { text: this.$t('travelOffer.active'), value: "isActif" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      offreVoyageDisponibleList: [],

      offreVoyageObject: {
        data: {
          compagnieTransportRaisonSociale: null,
        },
      },

      offreVoyageToActived: {
        datas: [],
      },
    };
  },

  methods: {
    //OBTENIR LISTE DES OFFRES DE VOYAGES DISPONIBLES PAR COMPAGNIE
    async obtenirOffreVoyageListParCompagnie() {
      this.offreVoyageObject.data.compagnieTransportRaisonSociale =
        this.$store.state.userAuthentified.compagnieTransportRaisonSociale;
      this.loading = true;
      await axios
        .post(API_RECUPERER_LISTE_OFFRE_VOYAGE, this.offreVoyageObject, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code != 800) {
              this.errorMsg = response.data.status.message;
              showErrorMessage();
            } else {
              this.offreVoyageDisponibleList = response.data.items;
            }
          } else {
            this.errorMsg = "Erreur";
            showErrorMessage();
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //ACTIVER L'OFFRE DE VOYAGE
    async activerOffreVoyage(offreVoyage) {
      var offreActived = { id: null };
      offreActived.id = offreVoyage.id;
      this.offreVoyageToActived.datas.push(offreActived);
      axios
        .post(API_ACTIVER_OFFRE_DE_VOYAGE, this.offreVoyageToActived, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code != 800) {
              this.$swal.fire(
                "Activation",
                response.data.status.message,
                "error"
              );
            } else {
              this.$swal.fire(
                "Activation",
                response.data.status.message,
                "success"
              );
              offreVoyage.isActif = true;
              this.obtenirOffreVoyageListParCompagnie();
            }
          } else {
            this.$swal.fire(
              "Activation",
              "Error lors de la validation",
              "error"
            );
          }
        })
        .catch((e) => {
          this.$swal.fire("Activation refusée", e, "error");
        });
    },

    //EDITER UNE OFFRE DE VOYAGE
    editerOffreVoyage(offreVoyage) {
      const parsedOffreVoyage = JSON.stringify(offreVoyage);
      localStorage.setItem("offreVoyage", parsedOffreVoyage);
      this.$router.push({ path: "/modifierOffreVoyage" });
    },
  },

  mounted() {
    this.obtenirOffreVoyageListParCompagnie();
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/admin/ui";

.sel-designation {
  font-weight: 700;
  color: $ov-navy;
}
</style>
